/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { isBoolean, isString } from '../../utils/core.utils'
import { DynamicCheckControlModel, DynamicCheckControlModelConfig } from '../dynamic-check-control.model'
import { DynamicFormControlLayout } from '../misc/dynamic-form-control-layout.model'

export const DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX = 'CHECKBOX'

export interface DynamicCheckboxModelConfig extends DynamicCheckControlModelConfig {
  indeterminate?: boolean
  openURLOnClick?: string
}

export class DynamicCheckboxModel extends DynamicCheckControlModel {
  indeterminate: boolean

  openURLOnClick: string

  readonly type: string = DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX

  constructor(config: DynamicCheckboxModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout)

    this.indeterminate = isBoolean(config.indeterminate) ? config.indeterminate : false
    this.openURLOnClick = isString(config.openURLOnClick) ? config.openURLOnClick : ''
  }
}
